import {
    IconButton,
    InputAdornment,
    TextField,
    TextFieldProps,
} from '@mui/material';
import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { colors } from 'common/constants';

// Number field controlled thuần (KHÔNG dùng react-hook-form).
// Nút -/+ cập nhật trực tiếp qua onChange(value). Dùng cho form quản lý bằng
// useState bên ngoài, không phụ thuộc FormProvider.
type BaseNumberInputProps = Omit<TextFieldProps, 'onChange' | 'value'> & {
    value: number | string;
    onChange: (value: string) => void;
    min?: number;
    max?: number;
    showMinus?: boolean;
    showPlus?: boolean;
    errorText?: string;
};

const BaseNumberInput: React.FC<BaseNumberInputProps> = ({
    value,
    onChange,
    min = 1,
    max,
    hiddenLabel = true,
    showMinus = true,
    showPlus = true,
    errorText,
    InputProps,
    ...props
}) => {
    const numValue = Number(value);
    const setClamped = (next: number) => {
        let result = next;
        if (result < min) result = min;
        if (max !== undefined && result > max) result = max;
        onChange(String(result));
    };
    return (
        <TextField
            {...props}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            hiddenLabel={hiddenLabel}
            type="number"
            error={!!errorText}
            helperText={errorText || ''}
            FormHelperTextProps={{
                sx: {
                    fontSize: '14px',
                    marginLeft: 0,
                    color: `${colors.textError} !important`,
                    fontWeight: '400',
                },
            }}
            InputProps={{
                ...InputProps,
                inputProps: { min, max },
                startAdornment: showMinus && (
                    <InputAdornment position="start">
                        <IconButton
                            aria-label="Decrease"
                            disabled={numValue <= min}
                            onClick={() => setClamped(numValue - 1)}
                        >
                            <RemoveIcon />
                        </IconButton>
                    </InputAdornment>
                ),
                endAdornment: showPlus && (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="Increase"
                            disabled={!!(max && numValue >= max)}
                            onClick={() => setClamped(numValue + 1)}
                        >
                            <AddIcon />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    );
};

export default BaseNumberInput;
